/*=========================================================================================
  File Name: getters.js
  namespace: Taxonomy
  Description: Vuex Store - Taxonomy getters
==========================================================================================*/

const getters = {
  getVideoTaxonomy: state => {
    return state.videoTaxonomy
  },
  getLabTaxonomy: state => {
    return state.labTaxonomy
  }
}

export default getters